import { render, staticRenderFns } from "./xdkaddcon.vue?vue&type=template&id=a650bd32&"
import script from "./xdkaddcon.vue?vue&type=script&lang=js&"
export * from "./xdkaddcon.vue?vue&type=script&lang=js&"
import style0 from "./xdkaddcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports